(function(window, document) {
  'use strict';

  var ehm = window.ehm;

  // show native multiple select control on iOS, Android etc
  if('ontouchstart' in window && !window.PointerEvent) {
    return;
  }

  var map = Array.prototype.map,
      forEach = Array.prototype.forEach,
      filter = Array.prototype.filter,
      reduce = Array.prototype.reduce;

  var idCounter = 0;

  var defaultConfig = {
    emptyText: '...'
  };
  var config = {};

  /**
   * Redraws classes etc of control
   */
  function updateView(wrap, selected, isOpen, select, optionElements, hoveringOption, optionsElement) {
    var options = select.options;
    // show or hide
    ehm.toggleClass(wrap, 'multiselect--open', isOpen);
    selected.setAttribute('aria-expanded', isOpen);

    // set correct class to options
    var i, l, option, optionElement, isActive, isDisabled, isSelected, wasSelected;
    var selectedTexts = [];
    for(i=0,l=options.length;i<l;i++) {
      option = options[i];
      optionElement = optionElements[i + (select.multiple ? 1 : 0)];

      isDisabled = option.disabled;
      isSelected = option.selected;
      wasSelected = optionElement.getAttribute('aria-selected') === 'true';

      optionsElement.setAttribute('aria-disabled', isDisabled);
      ehm.toggleClass(optionElement, 'multiselect__option--disabled', isDisabled);
      if(isSelected !== wasSelected) {
        ehm.toggleClass(optionElement, 'multiselect__option--selected', isSelected);
        optionElement.setAttribute('aria-selected', isSelected);
        optionElement.setAttribute('aria-checked', isSelected);
      }
      if(!isDisabled && isSelected) {
        selectedTexts.push(option.text);
      }
      // using class as hover marker instead of focus to allow tab to move to next/previous focusable element
      isActive = i === hoveringOption;

      ehm.toggleClass(optionElement, 'multiselect__option--hover', isActive);
      if(isActive) {
        optionsElement.setAttribute('aria-activedescendant', optionElement.id);
      }
    }

    if(hoveringOption === -1 && select.multiple) {
      // hovering fake 'all' option
      ehm.toggleClass(optionElements[0], 'multiselect__option--hover', true);
    } else if(select.multiple) {
      ehm.toggleClass(optionElements[0], 'multiselect__option--hover', false);
    }

    if(selectedTexts.length > 0) {
      selected.textContent = selectedTexts.join(', ');
    } else {
      selected.innerHTML = config.emptyText;
    }
  }

  function createMultiselectOption(option) {
    var element = document.createElement('div');
    var className = 'multiselect__option';
    var isSelected = option.selected;
    if(isSelected) {
      className += ' multiselect__option--selected';
    }
    element.setAttribute('aria-checked', isSelected);
    element.setAttribute('aria-selected', isSelected);
    element.className = className;
    element.textContent = option.text;
    element.setAttribute('data-value', option.value);
    element.setAttribute('role', 'option');
    // element.tabIndex = -1;
    element.id = 'multiselect__option-' + idCounter++;
    return element;
  }

  function createMultiselect(select) {
    var isMultiselect = select.multiple;
    var label = select.labels && select.labels[0];
    if(label && !label.id) {
      label.id = 'multiselect__label-' + idCounter++;
    }
    var wrap = document.createElement('div');
    wrap.className = 'multiselect';
    var selected = document.createElement('button');
    selected.className = 'multiselect__selected';
    selected.setAttribute('aria-haspopup', true);
    selected.setAttribute('aria-expanded', false);
    if(label) {
      selected.setAttribute('aria-labelledby', label.id);
    }
    selected.id = 'multiselect__selected-' + idCounter++;
    wrap.appendChild(selected);

    var options = document.createElement('div');
    options.className = 'multiselect__options';
    options.setAttribute('role', 'listbox');
    options.setAttribute('aria-multiselectable', isMultiselect);
    options.setAttribute('aria-required', select.required);
    options.id = 'multiselect__options-' + idCounter++;
    options.tabIndex = -1;
    selected.setAttribute('aria-owns', options.id);

    var optionElements = map.call(select.options, createMultiselectOption.bind(select));
    // if it's a multiple add an "all" option
    if(isMultiselect) {
      optionElements.unshift(createMultiselectOption.call(select, new Option('Välj alla', 'all')));
    }
    optionElements.forEach(function(o) { options.appendChild(o); });
    wrap.appendChild(options);
    select.parentNode.replaceChild(wrap, select);
    // make select visually hidden and remove it from tab order
    select.className += ' visually-hidden';
    select.setAttribute('aria-hidden', true);
    select.tabIndex = -1;
    wrap.appendChild(select);

    // internal state
    var isOpen = false;
    var hoveringOption = 0;
    var isInteracting = false;

    // initial draw
    redraw();

    // set up interaction
    select.onfocus = function(e) {
      e.preventDefault();
      e.stopPropagation();
      selected.focus();
    };
    select.onclick = function(e) {
      e.stopPropagation();
      // we have to stop propagation of click event, or the document click handler will fire and close the custom dropdown
    };
    selected.onclick = function(e) {
      isInteracting = true;
      e.preventDefault();
      // e.stopPropagation();
      open(!isOpen);
      redraw();
    };
    options.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      var target = e.target || e.srcElement;
      var selectedValue = target.getAttribute('data-value');
      if(selectedValue === null) return; // not an option
      if(!isMultiselect) {
        open(false);
        selected.focus();
      }
      hoveringOption = -1;
      if(selectedValue !== 'all') {
        forEach.call(select.options, function(o, i) {
          if(o.value === selectedValue) {
            o.selected = !o.selected && !o.disabled;
            hoveringOption = i;
          }
        });
      } else {
        var allAreSelected = reduce.call(select.options, function(tot, curr) {
          return tot && (curr.selected || curr.disabled);
        }, true);
        forEach.call(select.options, function(o, i) {
          if(allAreSelected) {
            o.selected = false;
          } else {
            o.selected = !o.disabled;
          }
        });
      }
      triggerChange();
      redraw();
    };
    options.onmousemove = function(e) {
      var target = e.target || e.srcElement;
      var selectedValue = target.getAttribute('data-value');
      if(selectedValue === null) return; // not an option
      hoveringOption = -1;
      forEach.call(select.options, function(o, i) {
        if(o.value === selectedValue) {
          hoveringOption = i;
        }
      });
      redraw();
    };
    function documentClickHandler(e) {
      if(isInteracting) {
        isInteracting = false;
        return;
      }

      var target = e.target || e.srcElement;
      var activeElement = document.activeElement;
      open(false);
      redraw();
      if(!activeElement || typeof activeElement.tabIndex === 'undefined') {
        selected.focus();
      }
    }
    // document.addEventListener('click', documentClickHandler, false);

    /**
     * Keydown listener for document when dropdown is open. Handles keyboard interaction with control.
     * @param  {KeyboardEvent} e The keydown event
     */
    function keydownListener(e) {

      switch(e.keyCode) {
        case 40: // down
          e.preventDefault();
          e.stopPropagation();
          hoveringOption += 1;
          if(hoveringOption > optionElements.length - 1) hoveringOption = 0;
          break;
        case 38: // up
          e.preventDefault();
          e.stopPropagation();
          hoveringOption -= 1;
          if(hoveringOption < 0) hoveringOption = optionElements.length - 1;
          break;
        case 32: // space
          e.preventDefault();
          e.stopPropagation();
          //select
          select.options[hoveringOption].selected = !select.options[hoveringOption].selected;
          if(isMultiselect) break; // jshint ignore:line
          // fall through on single select to close menu
        case 13: // return
          e.preventDefault();
          e.stopPropagation();
          //select and close on return
          select.options[hoveringOption].selected = true;
          triggerChange();
          open(false);
          selected.focus();
          break;
        case 27: // escape
          e.preventDefault();
          e.stopPropagation();
          //only close on escape
          triggerChange();
          open(false);
          selected.focus();
          break;
        case 9:
          e.preventDefault();
          e.stopPropagation();
          break;
//        default:
//          console.log('keyCode',e.keyCode,'event',e);
      }
      redraw();
    }

    //utils
    function open(newOpenState) {
      if(newOpenState) {
        hoveringOption = 0;
        document.addEventListener('keydown', keydownListener, false);
        document.addEventListener('click', documentClickHandler, false);
      } else {
        document.removeEventListener('keydown', keydownListener, false);
        document.removeEventListener('click', documentClickHandler, false);
      }

      if(newOpenState && newOpenState !== isOpen) {


        isOpen = newOpenState;
        redraw(); // have to redraw so options is guaranteed to be visible
        options.focus();
      }
      isOpen = newOpenState;
    }

    function redraw() {
      updateView(wrap, selected, isOpen, select, optionElements, hoveringOption, options);
    }

    function triggerChange() {
      var e = document.createEvent('HTMLEvents');
      e.initEvent('change', false, false);
      select.dispatchEvent(e);
    }
  }


  for(var k in defaultConfig) {
    if(window.multiselectOptions && k in window.multiselectOptions) {
      config[k] = window.multiselectOptions[k];
    } else {
      config[k] = defaultConfig[k];
    }
  }

  function recreateMultiselect(select) {
    if(select.parentNode.className.indexOf('multiselect') >= 0) {
      var wrap = select.parentNode;
      // check if multiple attribute and multiselect aria attribute differs and if not don't create a new multiselect
      var options = wrap.querySelector('.multiselect__options');
      if(select.multiple.toString() === options.getAttribute('aria-multiselectable')) {
        return;
      }
      // remove old one
      wrap.parentNode.replaceChild(select, wrap);
    }

    createMultiselect(select);
  }

  function updateMultiselects() {
    map.call(document.querySelectorAll('.select select'), recreateMultiselect);
  }

  updateMultiselects();

  ehm.updateMultiselects = updateMultiselects;

})(this, document);
